





























import { Component, Model, Vue } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import { IActionType, IStore } from '@/system/store'
import { uploadLocalisationKeys } from '@/features/upload/upload.localisation'
import { IParsingOptions } from '@/features/upload/store'
import { SAVE_PARSING_OPTIONS } from '@/features/upload/store/upload.store.action-types'

@Component
export default class AdvancedParsingOptionsDialog extends Vue {
  translations = uploadLocalisationKeys
  showDialog: boolean = false
  dateFormats: string[] = ['dd-mm-yyyy', 'dd-mm-yyyy hh:mm:ss', 'dd/mm/yyyy', 'dd/mm/yyyy hh:mm:ss']
  delimiterOptions: string[] = [',', ':', ';']

  @State(({ upload }: IStore) => upload.parsingOptions)
  parsingOptions!: IParsingOptions

  @Action(SAVE_PARSING_OPTIONS)
  saveParsingOptions!: IActionType

  currentDateFormat: string = ''
  delimiterFormat: string = ','

  public openDialog (): void {
    this.showDialog = true
    this.currentDateFormat = this.parsingOptions.xlsDateFormat
    this.delimiterFormat = this.parsingOptions.delimiterFormat
  }

  public selectSheet (dateFormat: string): void {
    this.currentDateFormat = dateFormat
  }

  public async closeDialog (): Promise<any> {
    await this.saveParsingOptions({
      xlsDateFormat: this.currentDateFormat,
      delimiterFormat: this.delimiterFormat
    })
  }
}
